export default "__VITE_ASSET__CXHMzPI9__"